// @flow
import React from 'react'
import Badge from '../../shared/BadgeWithLabel'
import PRTitle from '../../../containers/pull_request/Header/PRTitleContainer'
import BackToPRListLink from './BackToPRListLink'
import PRMetaData from '../../../containers/pull_request/Header/PRMetaDataContainer'

type Props = {
  model: Object,
  currentAccount: Object,
  deltaIssues: string,
  href: string
}

export default class PRHeaderTop extends React.Component<Props> {
  render () {
    return (
      <div className='flex-row' style={{borderBottom: '2px solid #d3d3d3'}}>
        <BackToPRListLink url={this.props.href} />
        <Badge value={this.props.deltaIssues} label='issue count' />
        <PRTitle {...this.props} header />
        <PRMetaData model={this.props.model} currentAccount={this.props.currentAccount} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/pull_request/Header/PRHeaderTop.js